import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../components/Header'
import BottomBar from '../components/BottomBar'
import { menu } from '../components/menu'
import Item from '../components/Item'
import Slider from '../components/Slider'

const CategoryPage = () => {
	const [showSearchPage, setShowSearchPage] = useState(false)
	const [categoryID, setCategoryID] = useState(false)

	const location = useLocation()
	useEffect(() => {
		setCategoryID(location.state.categoryID.split('-')[1])
	}, [])
	console.log(menu[categoryID], categoryID, 'idid')

	return (
		<div className='pb-24'>
			<Header setShowSearchPage={setShowSearchPage} setCategoryID={setCategoryID}></Header>
			<div
				className={showSearchPage ? 'd-none' : ''}
				style={{
					display: showSearchPage ? 'none' : 'block',
				}}
			>
				<Slider></Slider>
				<div
					className='pt-7 pb-10 px-8 rounded-2xl'
					style={{
						background:
							'radial-gradient(77.58% 77.58% at 98.83% 98.1%, rgba(235, 0, 255, 0.14) 53.18%, rgba(223, 227, 36, 0.0238) 100%), radial-gradient(100% 100% at 0% 0%, rgba(19, 31, 108, 0.37) 22.92%, rgba(19, 31, 108, 0) 100%)',
						boxShadow: '0px 0px 166px rgba(0, 0, 0, 0.32)',
					}}
				>
					{categoryID && (
						<>
							<div className='pb-7 font-["Open_Sans"] font-bold text-3xl leading-10'>{menu[categoryID].name}</div>
							{menu[categoryID].items.map((item, key) => {
								let itemEntry = Object.entries(item)[0]
								return <Item key={key} name={itemEntry[0]} price={itemEntry[1]}></Item>
							})}
						</>
					)}
				</div>
				<BottomBar></BottomBar>
			</div>
		</div>
	)
}

export default CategoryPage
